import { isTouchEnabled } from '../Theme';
import { GridSizeEnum } from '../modules/general-settings/enums/gridSize.enum';

export const GRID_ITEM_WIDTH = isTouchEnabled ? 42 : 40;

export const GRID_ITEM_OFFSET = isTouchEnabled ? 22 : 24;

const configureGridItemWidth = (gridSize: GridSizeEnum) => {
  switch (gridSize) {
    case GridSizeEnum.NORMAL:
      return GRID_ITEM_WIDTH;
    case GridSizeEnum.LARGE:
      return GRID_ITEM_WIDTH + GRID_ITEM_OFFSET;
    default:
      return GRID_ITEM_WIDTH;
  }
};
export default configureGridItemWidth;
